import { MenuItem, Select, TextField, FormControl } from "@material-ui/core";
import { PlayArrow, Assignment } from "@material-ui/icons";
import { useState } from "react";
import styled, { keyframes } from "styled-components";
import RuleFive from "./five";
import RuleFour from "./four";
import RuleOne from "./one";
import RuleThree from "./three";
import RuleTwo from "./two";

import axios from "axios";
import message from "../../helper/message";

const rulesApiPath = process.env.REACT_APP_RULES_API_PATH;

export default function Rules({ type, setFieldValue, values }) {
  var ruleValueType = `ruleValue-${type}`;
  var ruleType = `rule-${type}`;

  const [rule, setRule] = useState(values[ruleType]);

  function changeRule(e) {
    setRule(e.target.value);
    setFieldValue(`rule-${type}`, e.target.value);
  }

  function changeRuleValue(value) {
    console.log("changing the rule value: " + value);
    setFieldValue(ruleValueType, value);
  }

  async function handleTest() {
    if (!rulesApiPath) {
      message.error("URL de validação de regras não configurada");
      return;
    }

    try {
      const { data } = await axios.post(
        `${rulesApiPath}/validateConcurDateRules`,
        {
          rule: values[ruleType],
          ruleValue: values[ruleValueType],
          date: document.getElementById(`date-${type}`).value + " 03:00",
        }
      );
      message.sucess(
        `Retorno da data: ${new Date(data.message).toLocaleDateString()}`
      );
      console.log(data);
    } catch (e) {
      message.error(e.message);
    }
  }

  return (
    <ModernContainer>
      <RuleSection>
        <FieldLabel>
          <Assignment style={{ fontSize: '18px', marginRight: '8px', color: '#667eea' }} />
          Tipo de Regra
        </FieldLabel>
        <StyledFormControl fullWidth variant="outlined">
          <StyledSelect
            labelId={`${ruleType}-label`}
            id={ruleType}
            value={rule}
            onChange={changeRule}
          >
            <MenuItem value={1}>Dia + "X"</MenuItem>
            <MenuItem value={3}>Dia da Semana</MenuItem>
            <MenuItem value={4}>Janela Simples</MenuItem>
            <MenuItem value={5}>Janela Composta</MenuItem>
          </StyledSelect>
        </StyledFormControl>

        <RuleContent>
          {rule === 5 ? (
            <RuleFive
              onChange={changeRuleValue}
              value={values[ruleValueType] || "0|0"}
              type={type}
            />
          ) : rule === 2 ? (
            <RuleTwo onChange={changeRuleValue} value={values[ruleValueType]} />
          ) : rule === 3 ? (
            <RuleThree onChange={changeRuleValue} value={values[ruleValueType]} />
          ) : rule === 4 ? (
            <RuleFour onChange={changeRuleValue} value={values[ruleValueType]} />
          ) : (
            <RuleOne onChange={changeRuleValue} value={values[ruleValueType]} />
          )}
        </RuleContent>
      </RuleSection>

      <TestSection>
        <FieldLabel>Testar Regra</FieldLabel>
        <TestContainer>
          <StyledDateField>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              type="date"
              id={`date-${type}`}
              placeholder="Selecione uma data"
              defaultValue={new Date().toISOString().split("T")[0]}
              variant="outlined"
            />
          </StyledDateField>
          <TestButton onClick={handleTest} type="button">
            <PlayArrow style={{ fontSize: '20px' }} />
          </TestButton>
        </TestContainer>
      </TestSection>
    </ModernContainer>
  );
}

// Animações
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const ModernContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-family: 'Mulish', sans-serif;
  animation: ${fadeIn} 0.4s ease;
`;

const RuleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const FieldLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #2c3e50;
  display: flex;
  align-items: center;
  font-family: 'Mulish', sans-serif;
  margin-bottom: 4px;
`;

const StyledFormControl = styled(FormControl)`
  .MuiOutlinedInput-root {
    border-radius: 10px;
    background: white;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
    }

    &.Mui-focused {
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
    }
  }

  .MuiOutlinedInput-input {
    font-family: 'Mulish', sans-serif;
    font-size: 14px;
  }
`;

const StyledSelect = styled(Select)`
  font-family: 'Mulish', sans-serif;
`;

const RuleContent = styled.div`
  margin-top: 8px;
`;

const TestSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #e8e8e8;
`;

const TestContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

const StyledDateField = styled.div`
  flex: 1;

  .MuiOutlinedInput-root {
    border-radius: 10px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
    }

    &.Mui-focused {
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
    }
  }

  .MuiOutlinedInput-input {
    font-family: 'Mulish', sans-serif;
    font-size: 14px;
  }
`;

const TestButton = styled.button`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 10px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #e0e0e0;
    color: #9e9e9e;
    cursor: not-allowed;
    pointer-events: none;
    box-shadow: none;
  }
`;
